import { render, staticRenderFns } from "./EditLup.vue?vue&type=template&id=356f8b9c&"
import script from "./EditLup.vue?vue&type=script&lang=js&"
export * from "./EditLup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports